// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__bytBj","inputWrap":"CustomTip_inputWrap__Sy5KF"};